import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AddEditDistput from "../Components/Dialogs/AddEditDistput";
import DisputeTypesList from "../Components/Dialogs/DisputeTypesList";
import FilterSearch from "../Components/FilterSearch";
import PagesHeader from "../Components/PagesHeader";
import Table from "../Components/Table";
import { useMyContext } from "../context";
import useSupport from "../hooks/useSupport";
import Delete from "../Components/Dialogs/Delete";
import Pagination from "../Components/Pagination";
import useFilter from "../hooks/useFilter";
import Confirm from "../Components/Dialogs/Confirm";
import { useNavigate } from "react-router-dom";
import DisputCards from "../Components/DisputCards";

const DisputesCenter = () => {
  const { t } = useTranslation();

  const {
    deleteTypeLoading,
    handleDeleteType,
    distputs,
    distputsError,
    distputsIsError,
    distputsLoading,
    rejectDistPutLoading,
    handleRejectDistput,
    approveDistPutLoading,
    handleApproveDistput,
  } = useSupport();
  const navigate = useNavigate();
  useEffect(() => {
    if (distputsError?.status === 401) {
      sessionStorage.removeItem("ecoRefreshToken");
      sessionStorage.removeItem("ecoToken");
      navigate("/");
    }
  }, []);
  const { setFilter } = useFilter();
  const { handleOpenModal, openModal, type } = useMyContext();

  return (
    <div className="bg-third rounded-3xl p-6 flex flex-col gap-5">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <PagesHeader title={t("admin.disputes")} />
        <button
          type="button"
          onClick={() => handleOpenModal("disputeTypesList")}
          className="h-10 px-5 rounded-xl bg-secondary text-white text-sm font-semibold flex items-center justify-center gap-2 cursor-pointer hover:opacity-90 transition"
        >
          List Of Types
        </button>
      </div>

      <DisputCards data={distputs?.data?.status_counts} />
      <FilterSearch
        filterBy={[
          {
            label: "status",
            options: ["in_progress", "rejected", "pending", "completed"],
          },

          { label: "date_from" },
          { label: "date_to" },
        ]}
        type="support"
      />
      <Table
        tableHeader={[
          "Dispute ID",
          "Complainant",
          "Against",
          "trip id",
          "Created At",
          "Assigned To",
          "type",
          "status",
          "Priority",
          "Actions",
        ]}
        tableData={distputs?.data?.list}
        error={distputsError}
        isError={distputsIsError}
        loading={distputsLoading}
        type="distputs"
        openModal={openModal}
      />
      <Pagination
        paginate={{
          pageNumber: distputs?.data?.current_page,
          totalPages: distputs?.data?.total_pages,
          hasNext: distputs?.data?.has_next,
        }}
        setFilter={setFilter}
      />
      <DisputeTypesList />
      <AddEditDistput />
      <Delete
        title="Delete Distput Type"
        subTitle="Are you sure you want to delete this type?"
        loading={deleteTypeLoading}
        fun={handleDeleteType}
      />
      <Confirm
        title={type === "approve" ? "Approve Disput" : "Reject Disput"}
        subTitle={
          type === "approve"
            ? "Are you sure you want to approve this disput?"
            : "Are you sure you want to reject this disput?"
        }
        loading={
          type === "approve" ? approveDistPutLoading : rejectDistPutLoading
        }
        fun={type === "approve" ? handleApproveDistput : handleRejectDistput}
      />
    </div>
  );
};

export default DisputesCenter;
